import Typography from '@precis-digital/kurama/Typography'
import { styled } from '@precis-digital/kurama/utils'
import type { TypographyProps } from '@precis-digital/kurama/Typography'
import { type ReactNode, type ReactElement } from 'react'

interface TruncatedTextWithTooltipProps {
  children: ReactNode
  tooltipText: string
  variant?: TypographyProps['variant']
}

const TruncatedTextWithTooltip = ({
  children,
  tooltipText,
  variant = 'body2'
}: TruncatedTextWithTooltipProps): ReactElement => {
  return (
    <StyledTruncatedText variant={variant} title={tooltipText}>
      {children}
    </StyledTruncatedText>
  )
}

const StyledTruncatedText = styled(Typography)(() => ({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
}))

export default TruncatedTextWithTooltip
